import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import type {RootState} from './store';
import {employeePaymentRequest, requestPaymentLinkResponse} from '../lib/types';
import {requestPaymentPaymentApiCall} from '../api/requestlink.api';
//import axios from 'axios';

const requestPaymentconstData = {
  head: {
    version: null,
    timestamp: '',
    channelId: null,
    tokenType: '',
    clientId: null,
  },
  body: {
    linkId: '',
    linkType: '',
    longUrl: '',
    shortUrl: '',
    amount: '',
    expiryDate: '',
    isActive: false,
    merchantHtml: '',
    createdDate: '',
    notificationDetails: [
      {
        contact: '',
        notifyStatus: '',
        timestamp: '',
      },
    ],
    resultInfo: {
      resultStatus: '',
      resultCode: '',
      resultMessage: '',
    },
  },
};
interface requesLinkPaymentState {
  requestLinkPaymentData: requestPaymentLinkResponse;
  loading: boolean;
  error: string;
}

// Define the initial state using that type
const initialState: requesLinkPaymentState = {
  requestLinkPaymentData: requestPaymentconstData,
  loading: false,
  error: '',
};

export const requestLinkPayment = createAsyncThunk(
  'employee/requestlinkpayment',
  async (parameters: employeePaymentRequest, thunkApi) => {
    return requestPaymentPaymentApiCall(parameters)
      .then(response => {
        return response;
      })
      .catch(error => {
        return thunkApi.rejectWithValue(error.response.data);
      });
  },
);
export const requestLinkPaymentSlice = createSlice({
  name: 'linkPayment',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    resetLinkPaymentState: () => initialState,
  },
  extraReducers: builder => {
    builder.addCase(requestLinkPayment.pending, state => {
      state.loading = true;
    });
    builder.addCase(requestLinkPayment.fulfilled, (state, action) => {
      state.loading = false;
      state.requestLinkPaymentData = action.payload;
    });
    builder.addCase(requestLinkPayment.rejected, (state, action) => {
      state.error = action.toString();

      state.loading = false;
    });
  },
});

//Other code such as selectors can use the imported `RootState` type
export const {resetLinkPaymentState} = requestLinkPaymentSlice.actions;

export const requestLinkResponse = (
  state: RootState,
): requestPaymentLinkResponse =>
  state.requestLinkPaymentReducer.requestLinkPaymentData;
export const errorInrequestLink = (state: RootState): string =>
  state.requestLinkPaymentReducer.error;
export const requestLinkPaymentLoading = (state: RootState): boolean =>
  state.requestLinkPaymentReducer.loading;

export default requestLinkPaymentSlice.reducer;
